module.exports = __webpack_public_path__ + "static/img/p-s4-7.297f8b83.png";